<i18n>
{
    "en": {
        "header": "Widgets available for"
    },
    "ua": {
        "header": "Widgets available for"
    },
    "ru": {
        "header": "Widgets available for"
    }
}
</i18n>

<template>
  <component
    :is="require('../../_snippets/popup/popup_912x616').default"
    :visible.sync="opened"
  >
    <template slot="content" v-if="amo">
      <el-container>
        <el-header>
          <div>
            {{ $t("header") }}
            <span>{{ customer.name }}</span> ::
            <span>{{ amo.domain }}</span>
          </div>
        </el-header>
        <el-main>
          <div style="display: flex; flex-wrap: wrap">
            <component
              v-for="(widget, i) in widgets"
              :key="i"
              :is="require('../../widgets/elements/widget_card').default"
              :widget="widgets[i]"
              :amo="amo"
              is_in_customer_details
              @installWidget="handleInstall"
              @installIntegration="handleIntegrationInstall(...$event)"
            >
              <template v-slot:main>
                <component
                  :is="require('./widget_main_tabs').default"
                  :widget="widgets[i]"
                  :amo="amo"
                  :customer="customer"
                />
              </template>
            </component>
          </div>
        </el-main>
      </el-container>
    </template>
  </component>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "popup",
  props: {
    amo: {
      type: Object,
      default: function() {
        return {};
      }
    },
    customer: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  data() {
    return {
      opened: false
    };
  },
  methods: {
    getData() {
      return this.$api.query(this.refetchQueries[0]);
    },
    handleInstall(widget) {
      widget.installFor(this.customer, this.amo).then(res => {
        this.$log(res);
        this.getData()
          // .then(()=>{
          //     this.widgets.forEach((v)=>{
          //         if (v.name === widget.name){
          //             widget = v;
          //         }
          //     })
          // });
          .catch(() => {});
      });
    },

    handleIntegrationInstall(widget, type) {
      widget.installIntegrationFor(this.customer, this.amo, type).then();
    }
  },
  watch: {
    amo(v) {
      this.opened = !!this.amo;
    },
    opened(v) {
      if (v) {
        this.getData();
        return;
      }
      this.$emit("update:amo", null);
    }
  },
  computed: {
    ...mapGetters({
      widgets: "shared_widgets_list/widgets"
    }),
    refetchQueries() {
      return [
        {
          query: require("../../../graphql/widgets/widgets_list.graphql"),
          variables: {
            filter: {
              enabled: true
            },
            customer: this.customer,
            amo: this.amo
          }
        }
      ];
    }
  }
};
</script>

<style scoped></style>
